import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'

const ModalContainer = styled(Modal.Container)`
  max-width: 600px;
`
const StyledModalHeader = styled(Modal.Header)`
  align-items: start;
  margin-bottom: 0;
  & > div:first-child {
    margin-inline: auto;
  }
`
const StyledHeading = styled(Heading.H5)`
  margin-top: 24px;
`
const StyledModalContent = styled(Modal.Content)`
  text-align: center;
`

const StyledEmail = styled.span`
  color: #916ee8;
`

export const SuccessResetPasswordRequestModal = ({
  userAccountEmail,
  onClose
}: {
  userAccountEmail: string
  onClose: () => void
}): ReactElement => {
  return (
    <ModalContainer>
      <StyledModalHeader onClose={(): void => onClose()}>
        <StyledHeading>
          <FormattedMessage id="drivers.resetPassword" defaultMessage="A link has been sent" />
        </StyledHeading>
      </StyledModalHeader>
      <StyledModalContent>
        <p>
          <FormattedMessage
            id="drivers.resetPasswordSuccess"
            defaultMessage="An email was sent to {userAccountEmail} to change the password."
            values={{ userAccountEmail: <StyledEmail>{userAccountEmail}</StyledEmail> }}
          />
        </p>
      </StyledModalContent>
    </ModalContainer>
  )
}
